import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for offline caching
// Caches: map tiles, segment geometries, maintenance status
// Excludes: photos
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New app version available — will activate on next visit.');
  },
  onCacheUpdate: (timestamp) => {
    console.log('Trail data cache refreshed:', new Date(timestamp));
  },
});
